import { render, staticRenderFns } from "./NewAppUserDialog.vue?vue&type=template&id=6bcdcdf2&lang=pug&"
import script from "./NewAppUserDialog.vue?vue&type=script&lang=ts&"
export * from "./NewAppUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports